export enum RefTypeEnum {
    None = "None",
    Project = "Project",
    Sales = "SalesPlan"
}